import { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { data } from "jquery";
// import DataTable from "datatables.net";
import { MainArea, MainAreaHeader, MainAreaBody } from "../../layout/MainArea";
import { getDataTableDom, requestToServer } from "../../utils/appUtils";
// import TableDT from "../../UI/TableDT";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { GetConnMC, GetKKCinfo, GetTrackNMEA } from "../../../api";
import { Button } from 'primereact/button';
import { useAsyncEffect } from "../../UI/useAsyncEffect";

const ROUTE_URL = "/get_conn_knap";

function Performance(props) {
    clearInterval(window.timer)
    const [serverData, setServerData] = useState(null);
    const { showErrorPage, messageBox } = useOutletContext();
    const token = localStorage.getItem('token')
    const [arrTable, setArrTable] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState();
    const navigate = useNavigate();
    const [loadingStatus, setLoadingStatus] = useState(true)

    const handleAddRow = () => {
        navigate("./create");
    };


    useAsyncEffect(async () => {
        let offset = (currentPage - 1) * 10;
        let arr = []
         await GetKKCinfo(token, offset, 10).then((e) => {
            e.data.data.forEach((el) => {
                arr.push({kks: el.status === "normal" ? 1 : 0, time: new Date(el.timestamp).toLocaleString("ru")  })
            })
          })
         await GetConnMC(token, offset, 10).then((e) => {
            e.data.data.forEach((el) => {
                for (let i = 0; i < e.data.data.length; i++) {
                    arr[i].mc1 = el.psats[0].status === "normal" ? 1 : 0
                    arr[i].mc2 = el.psats[1].status === "normal" ? 1 : 0
                    arr[i].mc3 = el.psats[2].status === "normal" ? 1 : 0
                    arr[i].mc4 = el.psats[3].status === "normal" ? 1 : 0
                    arr[i].pulsn = 1
                }
            })
        
            setLoadingStatus(false)
            setArrTable(arr)
          }).catch(() => {
            setLoadingStatus(false)
            clearInterval(window.timer);
          })
        if (!date) {
            setDate(Date.now())
        }
    }, [currentPage])
  
    const handleClick =  async (event) => {
        if (loading) return;
       event && event.preventDefault();
       event && event.target.blur();
        //    refreshData();
        let offset = (currentPage - 1) * 10;
        let arr = []

        await GetKKCinfo(token, offset, 10).then((e) => {
            e.data.data.forEach((el) => {
                arr.push({kks: el.status === "normal" ? 1 : 0, time: new Date(el.timestamp).toLocaleString("ru")  })
            })
          })
          await GetConnMC(token, offset, 10).then((e) => {
            e.data.data.forEach((el) => {
                for (let i = 0; i < e.data.data.length; i++) {
                    arr[i].mc1 = el.psats[0].status === "normal" ? 1 : 0
                    arr[i].mc2 = el.psats[1].status === "normal" ? 1 : 0
                    arr[i].mc3 = el.psats[2].status === "normal" ? 1 : 0
                    arr[i].mc4 = el.psats[3].status === "normal" ? 1 : 0
                    arr[i].pulsn = 1
                }
            })
        
            setLoadingStatus(false)
          }).catch(() => {
            setLoadingStatus(false)
            clearInterval(window.timer);
          })
          setArrTable(arr)

        setLoading(true);
        setDate(Date.now())
        setTimeout(() => {
          setLoading(false);
        }, 650);
    }

    useEffect(() => {
        requestToServer(ROUTE_URL + "?crud", { method: 'GET' }, setServerData, showErrorPage, true);
        handleClick()
    }, []);

    if (serverData === null)
        return <MainArea loading />;

    return (
        <MainArea>
            <MainAreaHeader caption="Работоспособность" />
            <MainAreaBody containerClass="">
            <div className="container-fluid px-3 py-1 dashboard">
                    <div className="row g-3">  
                        <div className="cont-table">
                            <DataTable removableSort emptyMessage="Нет данных" value={arrTable} tableStyle={{ minWidth: '50rem' }}>
                                {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                <Column field="time" sortable header="Дата и время"></Column>
                                <Column field="pulsn" sortable header="ПУ-ЛСН"></Column>
                                <Column field="kks" sortable header="ККС"></Column>
                                <Column field="mc1" sortable header="МС 1"></Column>
                                <Column field="mc2" sortable header="МС 2"></Column>
                                <Column field="mc3" sortable header="МС 3"></Column>
                                <Column field="mc4" sortable header="МС 4"></Column>
                            </DataTable>
                            <div className="paginator">
                                <button
                                disabled={currentPage <= 1}
                                className="btn"
                                onClick={() => {
                                    setCurrentPage(currentPage - 1);
                                }}
                                >
                                {"<"}
                                </button>
                                <div className="text">{currentPage}</div>
                                <button
                                disabled={arrTable?.length < 10}
                                className="btn"
                                onClick={() => {
                                    setCurrentPage(currentPage + 1);
                                }}
                                >
                                {">"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div> 
    
                <div className="lower-line">
                    <div className="text-cont">
                        <div className="text">Состояние актуально на:</div>
                        <div className="text">{date ? new Date(date).toLocaleString() : ""}</div>
                    </div>
                    <Button className="btn-reload" loading={loading} label="Обновить сейчас" rounded onClick={handleClick}/>
              </div>
            </MainAreaBody>
        </MainArea>
    );
}

export default Performance;
